
import { Component, Vue } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import CompanyDetailForm from '../components/company_detail_form.vue'
import FullLoading from '@/components/full_loading/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

const examineStatus = {
    ing: {
        value: 0, name: '审核中'
    },
    pass: {
        value: 1, name: '审核通过'
    },
    fail: {
        value: 2, name: '审核不通过'
    }
}

@Component({
    name: 'enterprise-auth-detail',
    components: {
        CompanyDetailForm,
        FullLoading,
        CreateDetailLayout,
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private companyId = ''
    private company: any = { user: {}, company: {} }
    private isUpdateLoading = false
    private attachFile: any[] = []
    private loading = true
    private examineStatus = examineStatus

    get matchStatus() {
        const status = {
            [examineStatus.ing.value]: examineStatus.ing.name,
            [examineStatus.pass.value]: examineStatus.pass.name,
            [examineStatus.fail.value]: examineStatus.fail.name
        }
        // @ts-ignore
        return status[this.company.status]
    }

    private created() {
        this.companyId = this.$route.params.id
    }

    private async mounted() {
/*
        this.loading = true
        await this.getCompanyDetail()
        this.loading = false
*/
        this.$title('loading | 机构认证详情 - 庖丁')
        this.loading = true
        try {
            await this.getCompanyDetail()
        } catch (e) {
            console.error('加载机构认证详情失败:', e)
        } finally {
            this.loading = false
        }
    }

    /** 获取机构详情 */
    private async getCompanyDetail() {
        const params = {
            id: +this.companyId
        }
        const result = await EnterpriseService.getCompanyAuthDetail(params)
        if (result.status === 200) {
            // this.company = result.data
            // this.attachFile = [result.data.business_license, result.data.id_card_img]
            const data = result.data
            this.company = {
                ...data,
                company: data.company || {},
                user: data.user || {},
                address: data.address || '',
                business_code: data.business_code || '',
                business_license: data.business_license || '',
                id_card_img: data.id_card_img || '',
                created_at: data.created_at || data.createdAt || '',
                updated_at: data.updated_at || data.updatedAt || ''
            }
            this.attachFile = [data.business_license, data.id_card_img].filter(Boolean)
        }
    }

    private matchButtonType(status: number) {
        return this.company.status === status ? 'primary' : 'default'
    }

    private async changeStatus(status: number) {
        this.showLoading()
        const params = {
            id: +this.companyId,
            status
        }
        const result = await EnterpriseService.updateCompanyAuthStatus(params)
        this.hideLoading()
        if (result.status === 200) {
            this.company.status = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }

    private showLoading() {
        this.isUpdateLoading = true
    }

    private hideLoading() {
        this.isUpdateLoading = false
    }

}
